import { render } from "./MySubscriptions.vue?vue&type=template&id=8f0688d8&scoped=true&ts=true"
import script from "./MySubscriptions.vue?vue&type=script&lang=ts"
export * from "./MySubscriptions.vue?vue&type=script&lang=ts"

import "./MySubscriptions.vue?vue&type=style&index=0&id=8f0688d8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8f0688d8"]])

export default __exports__